import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './sport.reducer';
import { ISport } from 'app/shared/model/sport.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface ISportUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface ISportUpdateState {
  isNew: boolean;
  createdById: number;
  lastModifiedById: number;
}

export class SportUpdate extends React.Component<ISportUpdateProps, ISportUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      createdById: 0,
      lastModifiedById: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getUsers();
  }

  saveEntity = (event, errors, values) => {
    values.createdDate = new Date(values.createdDate);
    values.lastModifiedDate = new Date(values.lastModifiedDate);

    if (errors.length === 0) {
      const { sportEntity } = this.props;
      const entity = {
        ...sportEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/sport');
  };

  createdByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        createdById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            createdById: this.props.users[i].id
          });
        }
      }
    }
  };

  lastModifiedByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        lastModifiedById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            lastModifiedById: this.props.users[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { sportEntity, users, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="webBasedManualApp.sport.home.createOrEditLabel">Create or edit a Sport</h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : sportEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">ID</Label>
                    <AvInput id="sport-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="nameLabel" for="name">
                    Name
                  </Label>
                  <AvField
                    id="sport-name"
                    type="text"
                    name="name"
                    validate={{
                      required: { value: true, errorMessage: 'This field is required.' },
                      maxLength: { value: 50, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="iconNameLabel" for="iconName">
                    Icon Name
                  </Label>
                  <AvField
                    id="sport-iconName"
                    type="text"
                    name="iconName"
                    validate={{
                      maxLength: { value: 200, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="createdDateLabel" for="createdDate">
                    Created Date
                  </Label>
                  <AvInput
                    id="sport-createdDate"
                    type="datetime-local"
                    className="form-control"
                    name="createdDate"
                    value={isNew ? null : convertDateTimeFromServer(this.props.sportEntity.createdDate)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="lastModifiedDateLabel" for="lastModifiedDate">
                    Last Modified Date
                  </Label>
                  <AvInput
                    id="sport-lastModifiedDate"
                    type="datetime-local"
                    className="form-control"
                    name="lastModifiedDate"
                    value={isNew ? null : convertDateTimeFromServer(this.props.sportEntity.lastModifiedDate)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label for="createdBy.login">Created By</Label>
                  <AvInput
                    id="sport-createdBy"
                    type="select"
                    className="form-control"
                    name="createdBy.login"
                    onChange={this.createdByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="sport-createdBy" type="hidden" name="createdBy.id" value={this.state.createdById} />
                </AvGroup>
                <AvGroup>
                  <Label for="lastModifiedBy.login">Last Modified By</Label>
                  <AvInput
                    id="sport-lastModifiedBy"
                    type="select"
                    className="form-control"
                    name="lastModifiedBy.login"
                    onChange={this.lastModifiedByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="sport-lastModifiedBy" type="hidden" name="lastModifiedBy.id" value={this.state.lastModifiedById} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/sport" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">Back</span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp; Save
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  users: storeState.userManagement.users,
  sportEntity: storeState.sport.entity,
  loading: storeState.sport.loading,
  updating: storeState.sport.updating
});

const mapDispatchToProps = {
  getUsers,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SportUpdate);
